import { BaseChangeLog } from '@models/next/ChangeLog';
import { CustomsInstructionInsuranceTag } from '@models/next/CustomsInstruction';
import { z } from 'zod';

export const BaseCustomsRequestLog = BaseChangeLog.extend({
  customs_request: z.number(),
});

export const CustomsRequestLog = z.discriminatedUnion('edited_field', [
  // self start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('cargo_move_in_date'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('free_time'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('tentative_pickup_date'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('container_no'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('memo'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  // self end
  // booking inquiry start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.use_rcep'),
    before_value: z.boolean(),
    after_value: z.boolean(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.trade_condition'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.english_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.company_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.zipcode'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.address1'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.address2'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.principal_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.receiver.phone'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner.last_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner.first_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner.email'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner.cellphone'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.company_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.english_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.corporate_number'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.importer_code'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.real_time_account'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('booking_inquiry.owner_company.deferred_payment_account'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  // booking inquiry end
  // delivery request start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('delivery_request.truck_type'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('delivery_request.pickup_date'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  // delivery request end
  // arrival notice start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.address'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.delivery_destination'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.fax'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.principal_name'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.repository'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('arrival_notice.tel'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  // arrival notice end
  // pre alert start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.job_code'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.vessel'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.voyage'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.quantity'),
    before_value: z.number(),
    after_value: z.number(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.packages'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.measurement'),
    before_value: z.number(),
    after_value: z.number(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.gross_weight'),
    before_value: z.number(),
    after_value: z.number(),
  }),
  // pre alert end
  // vessel schedule start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.vessel_schedule.pol'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.vessel_schedule.pod'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.vessel_schedule.etd'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('pre_alert.vessel_schedule.eta'),
    before_value: z.string(),
    after_value: z.string(),
  }),
  // vessle schedule end
  // customs_instruction start
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('customs_instruction.insurance.tag'),
    before_value: CustomsInstructionInsuranceTag,
    after_value: CustomsInstructionInsuranceTag,
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('customs_instruction.insurance.company'),
    before_value: z.string().nullish(),
    after_value: z.string().nullish(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('customs_instruction.insurance.policy_no'),
    before_value: z.string().nullish(),
    after_value: z.string().nullish(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('customs_instruction.insurance.start'),
    before_value: z.string().nullish(),
    after_value: z.string().nullish(),
  }),
  BaseCustomsRequestLog.extend({
    edited_field: z.literal('customs_instruction.insurance.end'),
    before_value: z.string().nullish(),
    after_value: z.string().nullish(),
  }),
  // customs_instruction end
]);

export type CustomsRequestLog = z.infer<typeof CustomsRequestLog>;

export type CustomsRequestLogFormatters = {
  [K in CustomsRequestLog['edited_field']]?: (
    value: Extract<CustomsRequestLog, { edited_field: K }>['before_value'],
  ) => string;
};

export const exampleCustomsRequestLog: CustomsRequestLog = {
  id: 1,
  editor: 'Yaju',
  label: '海上保険 - 種類',
  created_at: '2023-03-24T05:35:04.885Z',
  updated_at: '2023-03-24T05:35:04.885Z',
  detail: '',
  customs_request: 1,
  edited_field: 'customs_instruction.insurance.tag',
  before_value: 'BLANKET',
  after_value: 'INDIVIDUAL',
};

export const exampleCustomsRequestLogs: CustomsRequestLog[] = [
  exampleCustomsRequestLog,
  {
    ...exampleCustomsRequestLog,
    id: 2,
    edited_field: 'booking_inquiry.use_rcep',
    before_value: false,
    after_value: true,
  },
];
